import { pathname as postiesParentsPathname } from "~/pages/posties/parents";

import NewsletterImage from "./newsletter.png";
import PostiesEventImage from "./posties-events.png";
import type { Props as WeHaveSoMuchForYouItemProps } from "./we-have-so-much-for-you-item";

export const weHaveSoMuchForYouItems: WeHaveSoMuchForYouItemProps[] = [
  {
    buttonProps: {
      as: "/posties",
      pathname: "/posties",
    },
    description:
      "Get exclusive access to Posties summer camps, workshops and other activities by signing up for our newsletter.",
    image: PostiesEventImage,
    title: "Posties Events",
  },
  {
    buttonProps: {
      as: "/posties/parents",
      hash: "#newsletter",
      pathname: postiesParentsPathname,
    },
    buttonText: "sign up",
    description:
      "Join our community for extra benefits, learning tips and fun topics in your inbox.",
    image: NewsletterImage,
    title: "Newsletter",
  },
];
